import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  modulesListRequest,
  modulesListSuccess,
  modulesListFailure,
} from '../reducers/modulesList';
import { authUserFailure } from '../reducers/login';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/user`;

function* modulesListAxios() {
  const state = yield select(fullState => fullState);
  const { selectedProgramId } = state.userProgramsFullReducer;
  const {   user: { userId },
  token } = state.loginReducer;

  console.log('getModules2', selectedProgramId)
  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}/${userId}/modulesMin?program_id=${selectedProgramId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerModulesListSaga() {
  try {
   
    const response = yield call(modulesListAxios);
    
    const responseFromModulesList = response.data;
    console.log('getModules3', responseFromModulesList)
   
      yield put(modulesListSuccess(responseFromModulesList.data.modules[0].modules));
    if (response.status === 500) {
      yield put(authUserFailure(response));
    }
  } catch (error) {
    console.log('getModules4', error)
    yield put(modulesListFailure(error.response));
  }
}

export function* watcherModulesListSaga() {
  yield takeLatest(modulesListRequest().type, workerModulesListSaga);
}
